import './src/main.css'
import BorderBox4 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox4.name, BorderBox4)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox4/index.js